import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import styles from './inspirecommila_pagina.module.scss';
import mentoria from './src/mentoria.jpeg';

const WHATSAPP_URL =
    'https://wa.me/5531995461766?text=' +
    encodeURIComponent('Olá, vim pelo Instagram e quero saber sobre o acompanhamento individual.');

const Mentoria_inspirecommila: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={styles.page}>
            <div className={styles.sheet}>
                <div className={styles.header}>
                    <Link to="/inspirecommila" className={styles.back} aria-label="Voltar">
                        <FaArrowLeft />
                    </Link>
                    <h1>Individual</h1>
                </div>

                <figure className={`${styles.hero} ${styles.wide}`}>
                    <img src={mentoria} alt="Mila em retrato de estúdio" />
                </figure>

                <div className={styles.corpo}>
                    <p className={styles.eyebrow}>Acompanhamento</p>
                    <h2 className={styles.titulo}>Um processo só seu</h2>
                    <p className={styles.lead}>
                        Um espaço mais próximo para olhar com profundidade para a sua história, emoções, padrões e
                        identidade.
                    </p>
                    <div className={styles.texto}>
                        <p>
                            Nos encontros não seguimos fórmula pronta. Partimos do momento que você está vivendo e
                            daquilo que hoje precisa ser trabalhado: feridas, crenças, autoestima, limites,
                            relacionamentos e novos comportamentos, sempre com a sua individualidade e com princípios
                            bíblicos nessa caminhada.
                        </p>
                        <p>
                            Além das conversas, uso exercícios e ferramentas para o que aparece no encontro começar a
                            ir para a vida real.
                        </p>
                    </div>
                    <div className={styles.meta}>
                        <span>Sob consulta</span>
                        <span>Vagas sob disponibilidade</span>
                    </div>
                    <a
                        href={WHATSAPP_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.cta}
                    >
                        Falar comigo
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Mentoria_inspirecommila;
